module.exports = __webpack_public_path__ + "media/site_templates/www.concreters.company/images/our_services_2-e9ec123dcd57fda0a076cd52fd672adc.jpg";